import React from 'react'
import { Typography, Box } from '@mui/material'

const CourseManagementPage: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Course Management
      </Typography>
      <Typography variant="body1">
        This page will allow course creators to manage courses and chapters.
      </Typography>
    </Box>
  )
}

export default CourseManagementPage
